module.exports = __webpack_public_path__ + "img/antman.2b63cf07.svg";